import React, { Component } from "react";
import PropTypes from "prop-types";
import { graphql } from "react-apollo";
import { queryGetLabels } from "Apollo";
import TreePicker from "module-common/TreePicker";

export default graphql(queryGetLabels)(
  class PickerMultiLabel extends Component {
    static propTypes = {
      includeCaseLabel: PropTypes.bool,
      includeCustomerLabel: PropTypes.bool,
      includeStreamLabel: PropTypes.bool,
      selectedLabels: PropTypes.array,
      onSelected: PropTypes.func
    };
    static defaultProps = {
      includeCaseLabel: true,
      includeCustomerLabel: true,
      includeStreamLabel: true,
      selectedLabels: []
    };
    state = { treeLabels: [] };

    componentWillReceiveProps(nextProps) {
      const {
        includeCaseLabel,
        includeCustomerLabel,
        includeStreamLabel,
        selectedLabels,
        data: { caseLabels, customerLabels, streamLabels }
      } = nextProps;

      const allLabelMap = new Map();
      if (includeCaseLabel && caseLabels) {
        for (const label of caseLabels) {
          allLabelMap.set(label.id, {
            label: label.displayName,
            isCollapsed: true,
            value: label,
            children: []
          });
        }
      }
      if (includeCustomerLabel && customerLabels) {
        for (const label of customerLabels) {
          allLabelMap.set(label.id, {
            label: label.displayName,
            isCollapsed: true,
            value: label,
            children: []
          });
        }
      }
      if (includeStreamLabel && streamLabels) {
        for (const label of streamLabels) {
          allLabelMap.set(label.id, {
            label: label.displayName,
            isCollapsed: true,
            value: label,
            children: []
          });
        }
      }

      // build tree
      const treeLabels = [];
      for (const label of allLabelMap.values()) {
        // select
        if (selectedLabels.some(row => label.value.id === row.value.id)) {
          label.selected = true;
        }

        // order in tree
        if (label.value.parentId === -1 || label.value.parentId === 0) {
          treeLabels.push(label);
        } else {
          const select = allLabelMap.get(label.value.parentId);
          if (select) {
            select.children.push(label);
          }
        }
      }
      this.setState({ treeLabels: treeLabels });
    }

    render() {
      return (
        <TreePicker
          {...this.props}
          tree={this.state.treeLabels}
          onChange={treeLabels => this.setState(treeLabels)}
        >
          {this.props.children}
        </TreePicker>
      );
    }
  }
);



// WEBPACK FOOTER //
// ./src/module-common/TreePickerMultiLabelWithQuery.js